import { create } from "zustand";

interface UIState {
  [x: string]: any;
  sidebarCollapsed: boolean;
  mobileMenuOpen: boolean; // 🆕 Added for Mobile
  cart: Record<number, number>; // variant_id → quantity
  
  toggleSidebar: () => void;
  toggleMobileMenu: () => void; // 🆕 Added for Mobile
  closeMobileMenu: () => void;  // 🆕 Added for Mobile
  
  addToCart: (variantId: number, quantity?: number) => void;
  updateCart: (variantId: number, quantity: number) => void;
  removeFromCart: (variantId: number) => void;
  clearCart: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: false,
  mobileMenuOpen: false, // Initial state
  cart: {},
  
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  
  // 🆕 Mobile actions implementations
  toggleMobileMenu: () => set((s) => ({ mobileMenuOpen: !s.mobileMenuOpen })),
  closeMobileMenu: () => set({ mobileMenuOpen: false }),
  
  addToCart: (variantId, quantity = 1) => set((s) => ({
    cart: { ...s.cart, [variantId]: (s.cart[variantId] ?? 0) + quantity },
  })),
  
  updateCart: (variantId, quantity) => set((s) => {
    const next = { ...s.cart };
    if (quantity <= 0) delete next[variantId];
    else next[variantId] = quantity;
    return { cart: next };
  }),
  
  removeFromCart: (variantId) => set((s) => {
    const next = { ...s.cart };
    delete next[variantId];
    return { cart: next };
  }),
  
  clearCart: () => set({ cart: {} }),
}));